/*
 * Назначение: утилиты форматирования для UI.
 * Функционал: даты на русском, относительное время, имена каналов и статусов.
 */

import type { Channel, DialogStatus, LeadStatus } from "./types";

const dateFmt = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const shortDateFmt = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
});

const timeFmt = new Intl.DateTimeFormat("ru-RU", {
  hour: "2-digit",
  minute: "2-digit",
});

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return dateFmt.format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatTime(iso: string | null | undefined): string {
  if (!iso) return "";
  try {
    return timeFmt.format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatShortDate(iso: string): string {
  try {
    return shortDateFmt.format(new Date(iso));
  } catch {
    return iso;
  }
}

const RTF = new Intl.RelativeTimeFormat("ru", { numeric: "auto" });

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return "—";
  const diffSec = Math.round((ts - Date.now()) / 1000);
  const abs = Math.abs(diffSec);
  if (abs < 60) return RTF.format(diffSec, "second");
  if (abs < 3600) return RTF.format(Math.round(diffSec / 60), "minute");
  if (abs < 86400) return RTF.format(Math.round(diffSec / 3600), "hour");
  return RTF.format(Math.round(diffSec / 86400), "day");
}

export const CHANNEL_LABEL: Record<Channel, string> = {
  web: "Сайт",
  telegram: "Telegram",
  max: "MAX",
};

export const DIALOG_STATUS_LABEL: Record<DialogStatus, string> = {
  active: "Активный",
  handed_off: "Передан менеджеру",
  lead_captured: "Заявка собрана",
  closed: "Завершён",
};

export const LEAD_STATUS_LABEL: Record<LeadStatus, string> = {
  new: "Новая",
  in_progress: "В работе",
  won: "Успешно закрыта",
  lost: "Без сделки",
};

export const KIND_LABEL: Record<string, string> = {
  company: "О компании",
  service: "Услуги",
  faq: "Частые вопросы",
  objection: "Возражения",
  rule: "Правила",
};
